module.exports = __webpack_public_path__ + "static/media/advertisers_section1.1e33a835.png";